<template>
  <v-dialog :value="confirm_deletion" @change="$emit('change', $event)" persistent width="300px">
    <v-card>
        <v-card-title class="headline">Tem certeza?</v-card-title>
        <v-card-text>{{ message }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            text
            @click="handleCancel"
            :disabled="loading"
          >Não</v-btn>
          <v-btn color="primary" text @click="handleDelete" :loading="loading">Sim</v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "confirm-delete-dialog",
  props: {
    confirm_deletion: Boolean,
    message: String
  },
  model: {
    prop: "confirm_deletion",
    event: "change"
  },
  data: () => ({
    loading: false
  }),
  methods: {
    async handleDelete(payload) {
      this.loading = true;
      await this.$listeners.deleteRecord();
      this.loading = false;
    },
    handleCancel() {
      this.$emit('change', false);
    }
  }
};
</script>